import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneNumberInput.css";

const PhoneNumberInput = (props) => {
  const [state, setState] = useState();

  const changeHandler = (value) => props.phoneChangeHandler(value);

  return (
    <PhoneInput
      className="form-control empty"
      {...props.inputProps}
      placeholder={props.placeholder}
      value={props.value ?? state}
      onChange={(value) => {
        setState();
        changeHandler(value);
      }}
    />
  );
};

export default PhoneNumberInput;
